import { searchTypeAtom } from "common/lib/atoms"
import { useRecoilState } from "recoil"

export default function useSearchType() {
    return useRecoilState(searchTypeAtom)
}
